import styled, { css } from 'styled-components'

interface PropsFormControl {
  actived: boolean; 
  disabled: boolean;
  error: boolean;
  selected: boolean;
}

export const FormControl = styled.div<PropsFormControl>`
  display: flex;
  flex-direction: column;
  width: 100%;
  .chevron__container{
    transform: translateY(13px);
    ${props => props.theme.motion}
    transition-property: transform;
  }
  .chevron__line1,
  .chevron__line2{
    ${props => props.theme.motion}
    stroke-width: 10;
    stroke-linecap: round;
    stroke: currentColor;
    transform-origin: 50px 50px;
  }
  .chevron__line1 {
    transform: rotate(40deg);
  }
  .chevron__line2 {
    transform: rotate(-40deg);
  }
  ${ props => props.actived && css`
    .chevron__container{
      transform: translateY(-13px);
    }
    .chevron__line1,
    .chevron__line2{

    }
    .chevron__line1 {
      transform: rotate(-40deg);
    }
    .chevron__line2 {
      transform: rotate(40deg);
    }
  `}

  ${props => !props.disabled && css`
    &:hover {
      button {
        ${ props => props.theme.states.hover.select }
      }
    }
  `}

  ${props => props.actived && css`
    .tmp-select__label{
      ${props => props.theme.states.actived.label}
    }

    button {
      ${props => props.theme.states.actived.select}
    }
  `}

  ${props => props.error && css`
    .tmp-select__label{
      ${props => props.theme.states.error.label}
    }

    button {
      ${props => props.theme.states.error.select}
    }
    .tmp-select__helper{
      ${props => props.theme.states.error.helper}
    }
    span {
      ${(props) => props.theme.states.error.helper}
    }
  `}

  ${props => props.disabled && css`
    .tmp-select__label{
      ${props => props.theme.states.disabled.label}
    }

    button {
      ${props => props.theme.states.disabled.select}
      ${props => props.theme.states.disabled.placeholder}
    }
    .tmp-select__helper{
      ${props => props.theme.states.disabled.helper}
    }
  `}

`

interface PropsLabel {
  htmlFor: string;
}

export const Label = styled.label<PropsLabel>`
  ${props => props.theme.label};
`

export const Select = styled.div`
  position: relative;
`

export const SelectButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${props => props.theme.motion};
  ${props => props.theme.select};
  &:focus-visible{
    ${ props => props.theme.states.focus }
  }
`

interface PropsOptions {
  actived: boolean; 
  disabled: boolean;
  selected: number;
  value: any;
}

export const OptionsList = styled.ol<PropsOptions>`
  list-style-type: none;
  position: absolute;
  margin: 0;
  padding: 0;
  min-width: 100%;
  width: max-content;
  height: auto;
  
  max-height: 350px;
  box-sizing: border-box;
  overflow-y: auto;

  display: none;
  opacity: 0;
  z-index: 2;

  ${ props => props.theme.menuItem }

  ${props => props.actived && css`
    display: block;
    opacity: 1;
  `}

  .tmp-list-item{
    border-bottom: 0;
    ${props => props.theme.menuItemLabel}

    &:focus-visible {
      ${props => props.theme.states.focus}
    }

    span{

    }
  }

  ${props => props.selected !== undefined && css`
    .tmp-list-item:nth-of-type(${props.selected}){
      ${props.theme.states.actived.menuItemLabel}
      span{
        color: currentColor;
      }

    }
  `}



  .tmp-list-item:last-of-type{
    border-color: transparent;
  }
`

export const Helper = styled.span`
  display: flex;
  ${props => props.theme.helper};
  .icon {
    ${props => props.theme.helper.icon};
  }
`

export const InputSearch = styled.input`
  padding: 4px;
  min-width: 30px;
  background: transparent;
  border: none;
  outline: none;

  opacity: 1;
  flex-grow: 1;
  text-overflow: ellipsis;
  font: inherit;
  color: currentColor;
  border: 0;
  height: 1.1876em;
  margin: 0;
  
  background: none;
  box-sizing: content-box;
  letter-spacing: inherit;
  
  width: auto;
  text-transform: none;
  
  line-height: 100%;
  font-weight: 400;
  font-size: 16px;
  font-family: Inter;
  text-align: left;
`